import "./Popup.css";
import closeIcon from "../../Assets/svg/close-icon.svg";
import { FC } from "react";
import { getColor } from "../../CalendarProps/CalendarProps";

interface PopupProps {
  close: () => void;
  children: React.ReactNode;
  handleButtonClick: () => void;
  category?: string;
  popupTitle: string;
  buttonTitle?: string;
  disabled?: boolean | undefined;
  hideButton?: boolean;
}

function Popup({
  children,
  close,
  handleButtonClick,
  category,
  popupTitle,
  buttonTitle,
  disabled,
  hideButton,
}: PopupProps): ReturnType<FC> {
  return (
    <div
      className="popup-overlay"
      onClick={() => {
        close();
      }}
    >
      <div
        className="popup-container"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div
          className="popup-header"
          style={{ backgroundColor: getColor(category || "") }}
        >
          <div className="popup-title">{popupTitle}</div>
          <button className="close-button" onClick={close}>
            <img src={closeIcon} alt="close icon" />
          </button>
        </div>
        {children}
        <div className="popup-button-container">
          <button className="popup-button secondary" onClick={close}>
            Schließen
          </button>
          {hideButton || (
            <button
              className={`popup-button primary ${disabled ? "disabled" : ""}`}
              onClick={handleButtonClick}
              disabled={disabled}
              type="submit"
            >
              {buttonTitle || "in Outlook übernehmen"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Popup;
